import { observer } from 'mobx-react-lite'
import { useOutletContext } from 'react-router'
import { type CallCenterViewModel } from '@/features/call-center/CallCenterViewModel'
import { CustomerLookupSectionContainer } from '@/features/call-center/CustomerLookupSection/CustomerLookupSectionContainer'
import { JobSectionContainer } from '@/features/call-center/JobSection/JobSectionContainer'
import { CallCenterFrameContainer } from './CallCenterFrameContainer'

/**
 * The customer lookup, or the tax situation of a client whose job has not
 * been created yet.
 */
export default observer(function CallCenterLookupPageContainer() {
  const vm = useOutletContext<CallCenterViewModel>()

  return (
    <CallCenterFrameContainer vm={vm}>
      {vm.jobVm.hasActiveClient ? (
        <JobSectionContainer vm={vm.jobVm} />
      ) : (
        <CustomerLookupSectionContainer
          vm={vm.customerLookupVm}
          onAddClient={vm.addClientDialogVm.show}
          onAddToWorkspace={vm.addSelectedClientToWorkspace}
        />
      )}
    </CallCenterFrameContainer>
  )
})
